import createTestId, { getTestId } from "../../../../fabrics/createTestId";

const HEADER_PREFIX = "header";

export const HEADER_TEST_ID = getTestId(HEADER_PREFIX);

export const createTestIdForHeader = createTestId(HEADER_PREFIX);
